<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div v-if="!viewdraftquestions" class="QPBuild-main-container">
			<div class="d-flex align-items-center justify-content-between">
				<div class="ml-2 qpc-heading-container">
					<span>Coding Test</span>
				</div>

				<div
					v-if="roles.includes('PUSH_CODING_TEST') && allQuestionsLength > 0"
				>
					<b-button class="addbtn" @click="goToCreateQuestion">
						<img src="../../assets/plusicon.svg" alt="" class="mr-2 mb-1" />
						<span class="">Create Question</span>
					</b-button>
				</div>
			</div>
			<div v-if="allQuestionsLength > 0" class="qpc-main-container mt-2 d-flex">
				<div
					class="p-3"
					style="width: 20%; border-right: 1px solid rgba(196, 196, 196, 0.5)"
				>
					<div class="d-flex align-items-center justify-content-between">
						<span class="qpc-totalQuestext">Total Questions</span>
						<span class="qpc-totalQuesnum">{{ allquestions.length }}</span>
					</div>
					<hr />
					<div class="qpc-left-card">
						<div
							@click="viewDiff = !viewDiff"
							class="d-flex align-items-center justify-content-between pointer"
						>
							<span class="qpc-diff-text">Difficulty Levels</span>
							<span v-if="viewDiff"
								><img src="../../assets/uparrow.svg" alt="" />
							</span>
							<span v-else><img src="../../assets/downarrow.svg" alt=""/></span>
						</div>
						<div v-if="viewDiff" class="pointer">
							<div class="">
								<div
									class="qpc-checkbox-parent ml-2"
									v-for="option in difficultoptions"
									:key="option.value"
								>
									<b-form-checkbox
										:value="option.value"
										v-model="difficultylevel"
										@change="getallcodingquestions"
										><span class="qpc-checkbox-text">{{ option.text }}</span>
									</b-form-checkbox>
								</div>
							</div>
						</div>
					</div>
					<div class="qpc-left-card mt-3">
						<div
							@click="(viewTags = !viewTags), getTags"
							class="d-flex align-items-center justify-content-between pointer"
						>
							<span class="qpc-diff-text">Tags</span>
							<span v-if="viewTags"
								><img src="../../assets/uparrow.svg" alt="" />
							</span>
							<span v-else>
								<img src="../../assets/downarrow.svg" alt="" />
							</span>
						</div>
						<div v-if="viewTags">
							<div class="relativeclass mt-2 qpc-search-bar">
								<div class="searchiconqp">
									<img src="../../assets/searchicon.svg" alt="" />
								</div>
								<b-form-input
									placeholder="Search"
									type="search"
									class="search-ques"
									v-model="searchtag"
								></b-form-input>
							</div>
							<div class="qpc-checkbox-parent" v-if="allTags.length > 0">
								<b-form-checkbox
									class="mt-3 testconfig-checkbox"
									v-model="selectall"
									@change="checkSelectAll"
								>
									<div class="qpc-checkbox-text mt-1">Select All</div>
								</b-form-checkbox>
							</div>
							<div class="qpc-checkbox-parent" v-else>
								<div class="qpc-checkbox-text mt-1">No results...</div>
							</div>
							<div class="qpc-tags-overflow">
								<div
									class="qpc-checkbox-parent ml-2"
									v-for="(i, k) in allTags"
									:key="k"
								>
									<b-form-checkbox
										:value="i"
										v-model="Tags"
										name="role-check-button"
									>
										<span class="qpc-checkbox-text">
											{{ i }}
										</span>
									</b-form-checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div style="width: 80%" class="position-relative">
					<div class="p-3">
						<div class="d-flex justify-content-between qpc-parent">
							<div class="relativeclass qpc-search-bar" style="width: 50%">
								<div class="searchiconqp">
									<img src="../../assets/searchicon.svg" alt="" />
								</div>
								<b-form-input
									placeholder="Search Questions"
									class="search-ques"
									v-model="searchQuery"
									@input="handleInput"
									type="search"
								></b-form-input>
							</div>
							<div class="d-flex justify-content-end">
								<b-button
									class="viewdraft mb-3 mt-1 mr-3"
									variant="outline"
									@click="(viewdraftquestions = true), setDraft()"
								>
									<img src="../../assets/drafticon.svg" alt="" class="mr-2" />
									View Draft
								</b-button>
								<div class="d-flex">
									<div class="relativeclass mr-3 mt-1 switchtext pointer">
										<div
											ref="qbdropsort1"
											class="sortcontainer d-flex justify-content-around align-items-center"
											@click="showsortcard = !showsortcard"
										>
											<div class="sorttext mr-3">Sort</div>
											<div class="sortline ml-3"></div>
											<div class="sortordertext ml-2 mr-3">
												{{ sort_selected }}
											</div>
											<div
												v-if="showsortcard"
												style="position: absolute; right: 5px"
											>
												<img src="../../assets/uparrow.svg" alt="" />
											</div>
											<div v-else style="position: absolute; right: 5px">
												<img src="../../assets/downarrow.svg" alt="" />
											</div>
										</div>
										<div
											v-if="showsortcard"
											ref="qbdropsort"
											v-closable="{
												exclude: ['qbdropsort', 'qbdropsort1'],
												handler: 'hidesortoptions',
											}"
										>
											<div
												class="tnt-sortcard-auto jdtypecard p-1 testdashboard"
											>
												<div
													class="xMarkCancel pointer z-10"
													@click="showsortcard = !showsortcard"
												>
													<img src="../../assets/xmark.svg" alt="" />
												</div>
												<b-form-group
													class="sec-mcq-datacard jdtyperadio"
													v-for="i in sortoptions"
													:key="i.value"
												>
													<b-form-radio
														class="m-1"
														size="sm"
														v-model="sort_selected"
														@change="saveSort(i.value)"
														:value="i.text"
													>
														{{ i.text }}
													</b-form-radio>
												</b-form-group>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="allquestions.length > 0"
							class="position-relative qpc-ques-container p-4"
						>
							<div v-for="(question, k) in allquestions" :key="k" class="mt-3">
								<span class="qpc-totalQuestext"
									>Q {{ pageStart + k }}.&nbsp;</span
								><span class="qpc-totalQuesnum ml-1">{{ question.title }}</span>
								<div
									class="d-flex ml-4 mt-3 pb-4"
									style="border-bottom: 1px solid #c4c4c4"
								>
									<div style="width: 90%">
										<div
											class="qpc-question-text"
											v-html-safe="limitedquestion(question)"
										></div>
										<div class="d-flex align-items-center mt-2 d-flex">
											<span class="qpc-tags-text mr-1">Tags: </span>
											<div
												class="qpc-tags-text ml-1"
												v-for="(i, index) in question.questionTags"
												:key="index"
											>
												{{ i
												}}<span v-if="index < question.questionTags.length - 1"
													>,
												</span>
											</div>
										</div>
										<div class="d-flex align-items-center mt-3">
											<div
												class="qpc-small-box"
												v-if="question.difficultyLevel"
											>
												Difficulty : {{ question.difficultyLevel }}
											</div>
											<div class="qpc-small-box">
												Marks : {{ question.marks }}
											</div>
											<div class="qpc-small-box">
												Category :
												<b><span v-html-safe="question.category"></span></b>
											</div>
										</div>
									</div>
									<div
										style="width: 33%"
										class="d-flex align-items-end justify-content-end"
									>
										<div
											class="mr-4 mt-3 pointer"
											v-b-tooltip.hover.top="{ variant: 'secondary' }"
											title="Try Question"
											@click="goToTryQuestion(question.questionKey)"
										>
											<img src="../../assets/double arrow.svg" alt="" />
											<span style="color: #72738e; font-size: 14px">
												&nbsp;
												<u> Try Question </u>
											</span>
										</div>
										<span
											v-if="roles.includes('PUT_CODING_TEST')"
											class="mr-3 pointer"
											@click="goToEditQuestion(question.questionKey)"
										>
											<img
												v-b-tooltip.hover.top="{ variant: 'secondary' }"
												title="Edit"
												src="../../assets/edit_Pencil.svg"
												alt=""
											/>
										</span>
										<span
											class="pointer mr-3"
											@click="
												openModal(question.questionKey, pageStart + k),
													(openmodal = true)
											"
										>
											<img
												v-if="!openmodal || k != qno - 1"
												v-b-tooltip.hover.top="{ variant: 'secondary' }"
												title="Preview"
												src="../../assets/preview eye.svg"
												alt=""
											/>
											<img
												v-else-if="openModal && k == qno - 1"
												src="../../assets/visibility_off.svg"
												alt=""
											/>
										</span>
										<span
											v-if="roles.includes('DELETE_CODING_TEST')"
											class="mr-4 pointer"
											@click="
												goToDeleteQuestion(false, question.questionKey),
													(qno = k + 1)
											"
										>
											<img
												v-b-tooltip.hover.top="{ variant: 'secondary' }"
												title="Delete"
												src="../../assets/deleteicon.svg"
												alt=""
											/>
										</span>
									</div>
								</div>
							</div>
						</div>
						<div
							v-else-if="
								allquestions.length == 0 &&
									searchQuery != '' &&
									difficultylevel.length == 0 &&
									Tags.length == 0
							"
							class="position-relative qpc-ques-container p-4"
						>
							<div
								class="d-flex flex-column align-items-center justify-content-center h-100"
							>
								<div>
									<img src="../../assets/nosearchdataCT.svg" alt="" />
								</div>
								<div class="mt-4 topicDescBreak">
									<span class="searchnotfoundct"
										>No matching results found for
										<span class="searchtextct" style="word-wrap: break-word">
											"{{ searchQuery }}"
										</span>
									</span>
								</div>
							</div>
						</div>
						<div
							class="d-flex flex-column align-items-center justify-content-center h-100"
							style="right: 37rem; position: absolute; bottom: 14px"
							v-else-if="
								allquestions.length == 0 &&
									(difficultylevel.length > 0 || Tags.length > 0)
							"
						>
							<div>
								<img src="../../assets/nosearchdataCT.svg" alt="" />
							</div>
							<div class="mt-4">
								<span class="searchnotfoundct">No questions available.</span>
							</div>
						</div>
					</div>

					<div
						class="qpc-qbpaginaTion d-flex justify-content-between align-items-center"
					>
						<div style="width: 45%" class="d-flex">
							<span class="qb-gotopage-text p-1">Go to page</span>
							<b-form-input
								style="width: 9%"
								type="text"
								v-model.trim="goToPage"
								class="qb-pagination-num mr-1"
								min="1"
								@keypress="allowNumbers($event)"
								@keyup.enter="
									goToPage === null ||
									goToPage == '' ||
									!isValidPage(goToPage) ||
									allquestions.length == 0
										? ''
										: goToPageNo(goToPage)
								"
							></b-form-input>
							<b-button
								:disabled="
									goToPage === null ||
										goToPage == '' ||
										!isValidPage(goToPage) ||
										allquestions.length == 0
								"
								class="qb-pagination-addbtn"
								@click="goToPageNo(goToPage)"
							>
								<span
									><img src="../../assets/whiterightarrow.svg" alt=""
								/></span>
							</b-button>
						</div>

						<div style="width: 30%" class="pagination">
							<b-pagination
								align="center"
								v-model.number="currentPage"
								@input="goToPageNum()"
								:total-rows="total"
								:per-page="question_count"
								first-number
								last-number
							>
								<template #prev-text
									><span><img src="../../assets/leftvector.svg" alt="" /> </span
								></template>
								<template #next-text
									><span><img src="../../assets/rightarrow.svg" alt=""/></span
								></template>
							</b-pagination>
						</div>
						<div
							style="width: 25%"
							class="qb-gotopage-text mr-2 d-flex justify-content-end"
						>
							Results : <span class="ml-1 mr-1" v-if="pageStart > total">0</span
							><span class="ml-1 mr-1" v-else> {{ pageStart }}</span> -
							{{ pageEnd }} <span class="pl-1"></span> of
							<span class="pr-1"></span>{{ total }}
						</div>
					</div>
				</div>
				<b-modal
					size="lg"
					id="viewQues"
					centered
					hide-footer
					hide-header
					@hidden="openmodal = false"
				>
					<b-overlay
						id="overlay-background"
						:show="showOverlay"
						variant="white"
						:opacity="overlayOpacity"
						:blur="overlayBlur"
						rounded="sm"
					>
						<div class="qpc-modal-head-text">View Question</div>
						<div @click="$bvModal.hide('viewQues')" class="xMarkCancel">
							<img src="../../assets/xmark.svg" alt="" />
						</div>
						<hr />
						<div class="qpc-modal-card">
							<div class="d-flex align-items-center mt-3 ml-4">
								<div class="qpc-small-box">
									Difficulty Level: {{ question.difficultyLevel }}
								</div>
								<div class="qpc-small-box">Marks: {{ question.marks }}</div>
								<div class="qpc-small-box">
									Category : <b>{{ question.category }}</b>
								</div>
							</div>
							<div class="qpc-tags-text mt-3 ml-4 d-flex">
								Tags :
								<div
									class="ml-1"
									v-for="(tag, k) in question.questionTags"
									:key="k"
								>
									{{ tag
									}}<span v-if="k < question.questionTags.length - 1">,</span>
								</div>
							</div>
							<div class="mt-3">
								<span class="qpc-totalQuestext">Q.{{ qno }}&nbsp;</span
								><span
									class="qpc-totalQuesnum ml-1"
									style="word-break: break-word"
									>{{ question.title }}</span
								>
							</div>
							<div
								class="qpc-full-ques ml-4 mr-4 mt-3"
								v-html-safe="question.question"
							></div>
							<div class="qpc-left-card mt-3 ml-4 mr-4">
								<span class="qpc-modal-card-text">Constraints:</span>
								<div
									class="mt-3 qpc-tags-text"
									v-html-safe="question.constraints"
								></div>
							</div>
							<div class="qpc-left-card mt-2 ml-4 mr-4">
								<span class="qpc-modal-card-text">Sample</span>
								<div class="p-3 qpc-tags-text d-flex flex-column">
									Input: <span v-html-safe="question.sampleInput"> </span>
									Output:
									<span v-html-safe="question.sampleOutput"> </span>
								</div>
							</div>
							<template v-if="question.testCases.length > 0">
								<div class="qpc-left-card mt-2 ml-4 mr-4">
									<span class="bct-preview-head">Test Cases</span>
									<div class="d-flex">
										<div class="bct-many-testCase-left" style="width: 25%">
											<!--********************   SELECTED TEST CASE CLASS  *********************-->

											<!--********************   UNSELECTED TEST CASE  CLASS *********************-->

											<div
												v-for="(tc, k) in question.testCases"
												:key="k"
												@click="selecttestcase(k)"
												:class="
													viewtestcase == k
														? 'p-2 bct-many-testCase-sel-text'
														: 'p-2 bct-many-testCase-text'
												"
											>
												Test Case {{ k + 1 }}
											</div>
										</div>
										<div class="bct-many-testCase-right" style="width: 75%">
											<div class="bct-TC-card p-3 m-2">
												<span class="bct-preview-head">Input: </span>

												<div class="bct-card-subtext mt-2">
													{{ question.testCases[viewtestcase].inputValue }}
												</div>
											</div>
											<div class="bct-TC-card p-3 m-2">
												<span class="bct-preview-head">Output: </span>
												<div class="bct-card-subtext mt-2">
													{{ question.testCases[viewtestcase].outputValue }}
												</div>
											</div>
											<div class="bct-TC-card p-3 m-2">
												<span class="bct-preview-head"
													>Visible:
													<div class="bct-card-subtext mt-2">
														{{ question.testCases[viewtestcase].visible }}
													</div></span
												>
											</div>
										</div>
									</div>
								</div>
							</template>
						</div>
					</b-overlay>
				</b-modal>
				<b-modal id="modal-delete" centered hide-footer hide-header>
					<div
						class="modalheading d-flex align-items-center justify-content-between"
					>
						Caution
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
					<div class="xMarkCancel" @click="$bvModal.hide('modal-delete')">
						<img src="../../assets/xmark.svg" alt="" />
					</div>
					<hr />
					<div class="mt-3 caution-modal-text">
						<span style="word-wrap: break-word"
							>Are you sure you want to delete question {{ qno }} ?</span
						>
					</div>
					<div class="normaltext">
						<span class="asterik">*</span
						><span>Please note this action cannot be undone</span>
					</div>
					<div class="d-flex align-items-center justify-content-end mt-3">
						<b-button class="addbtn" @click="goToDeleteQuestion(true)"
							>Delete</b-button
						>
					</div>
				</b-modal>
			</div>
			<div
				v-else-if="allQuestionsLength == 0"
				class="qpc-main-container w-100 mt-2"
			>
				<div class="d-flex justify-content-between align-items-center">
					<img
						class="pointer"
						@click="goToCreateQuestion"
						src="../../assets/codetest_add.svg"
						alt=""
					/>
					<div style="position: absolute; top: 147px; right: 26px">
						<b-button
							class="viewdraft mb-3 mt-1 mr-3"
							variant="outline"
							@click="(viewdraftquestions = true), setDraft()"
						>
							<img src="../../assets/drafticon.svg" alt="" class="mr-2" />
							View Draft
						</b-button>
					</div>
				</div>
				<div class="codetestillus">
					<div class="codenodatatext">
						No questions have been created yet. Please click on the<span
							style="font-weight: 600"
						>
							“Add New Question” </span
						><br />
						at the top to create a new
					</div>
				</div>
			</div>
		</div>
		<!-- DRAFT QUESTIONS DISPLAYED -->
		<div v-else-if="viewdraftquestions" class="QPBuild-main-container">
			<div class="d-flex align-items-center justify-content-between">
				<div class="d-flex justify-content-between">
					<div class="pointer" @click="showAllQuestion">
						<img src="../../assets/icons/Reports/bckarrow.svg" alt="" />
					</div>
					<div class="heading headtext ml-3">
						<span>Draft Questions</span>
					</div>
				</div>
				<div v-if="roles.includes('PUSH_CODING_TEST') && draftQuestionsLen > 0">
					<b-button class="addbtn" @click="goToCreateQuestion">
						<img src="../../assets/plusicon.svg" alt="" class="mr-2 mb-1" />
						<span class="">Create Question</span>
					</b-button>
				</div>
			</div>
			<div v-if="draftQuestionsLen > 0" class="qpc-main-container mt-2 d-flex">
				<div style="width: 100%" class="position-relative">
					<div class="p-4">
						<div class="d-flex justify-content-between mb-3">
							<div
								class="relativeclass qpc-search-bar ml-3 mt-1"
								style="width: 50%"
							>
								<div class="searchiconqp">
									<img src="../../assets/searchicon.svg" alt="" />
								</div>
								<b-form-input
									placeholder="Search Questions"
									class="search-ques"
									@input="handleInput"
									v-model="searchQuery"
									type="search"
								></b-form-input>
							</div>
							<div class="d-flex">
								<div class="relativeclass mr-3 mt-1 switchtext pointer">
									<div
										ref="qbdropsort1"
										class="sortcontainer d-flex justify-content-around align-items-center"
										@click="showsortcard = !showsortcard"
									>
										<div class="sorttext mr-3">Sort</div>
										<div class="sortline ml-3"></div>
										<div class="sortordertext mr-3">
											{{ sort_selected }}
										</div>
										<div style="position: absolute; right: 10px">
											<img
												v-if="showsortcard"
												src="../../assets/uparrow.svg"
												alt=""
											/>
											<img v-else src="../../assets/downarrow.svg" alt="" />
										</div>
									</div>
									<div
										v-if="showsortcard"
										ref="qbdropsort"
										v-closable="{
											exclude: ['qbdropsort', 'qbdropsort1'],
											handler: 'hidesortoptions',
										}"
									>
										<div class="tnt-sortcard-auto jdtypecard p-1 testdashboard">
											<div
												class="xMarkCancel pointer z-10"
												@click="showsortcard = !showsortcard"
											>
												<img src="../../assets/xmark.svg" alt="" />
											</div>
											<b-form-group
												class="sec-mcq-datacard jdtyperadio"
												v-for="i in sortoptions"
												:key="i.value"
											>
												<b-form-radio
													class="m-1"
													size="sm"
													v-model="sort_selected"
													@change="saveSort(i.value)"
													:value="i.text"
												>
													{{ i.text }}
												</b-form-radio>
											</b-form-group>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="draftquestions.length > 0"
							class="position-relative qpc-ques-container p-4"
						>
							<div
								v-for="(question, k) in draftquestions"
								:key="k"
								class="mt-3"
							>
								<span class="qpc-totalQuestext"
									>Q {{ k + pageStartDarft }}.&nbsp;</span
								><span class="qpc-totalQuesnum ml-1">{{ question.title }}</span>
								<div
									class="d-flex ml-4 mt-3 pb-4"
									style="border-bottom: 1px solid #c4c4c4"
								>
									<div style="width: 80%">
										<div
											class="qpc-question-text"
											v-html-safe="question.question"
										></div>
										<div class="d-flex align-items-center mt-2">
											<span class="qpc-tags-text">Tags: </span>
											<div
												class="qpc-tags-text ml-1"
												v-for="(i, index) in question.questionTags"
												:key="index"
											>
												{{ i
												}}<span v-if="index < question.questionTags.length - 1"
													>,
												</span>
											</div>
										</div>
										<div class="d-flex align-items-center mt-3">
											<div
												class="qpc-small-box"
												v-if="question.difficultyLevel"
											>
												Difficulty : {{ question.difficultyLevel }}
											</div>
											<div class="qpc-small-box">
												Marks : {{ question.marks }}
											</div>
											<div class="qpc-small-box">
												Category :
												<b><span v-html-safe="question.category"></span></b>
											</div>
										</div>
									</div>
									<div
										style="width: 20%"
										class="d-flex justify-content-end"
										v-if="roles.includes('PUSH_CODING_TEST')"
									>
										<div>
											<b-button
												class="addbtn pointer"
												@click="goToCreateQuestion(question.questionKey)"
											>
												<span>Continue to Create</span>
											</b-button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-else-if="draftquestions.length == 0 && searchQuery != ''"
							class="position-relative qpc-ques-container p-4"
						>
							<div
								class="d-flex flex-column align-items-center justify-content-center h-100"
								v-if="searchQuery != ''"
							>
								<div>
									<img src="../../assets/nosearchdataCT.svg" alt="" />
								</div>
								<div class="mt-4 topicDescBreak">
									<span class="searchnotfoundct"
										>No matching results found for
										<span class="searchtextct" style="word-wrap: break-word">
											"{{ searchQuery }}"
										</span>
									</span>
								</div>
							</div>
						</div>
						<div v-else class="position-relative qpc-ques-container p-4">
							<div
								class="d-flex flex-column align-items-center justify-content-center h-100"
								v-if="searchQuery != ''"
							>
								<div>
									<img src="../../assets/nosearchdataCT.svg" alt="" />
								</div>
								<div class="mt-4 topicDescBreak">
									<span class="searchnotfoundct"
										>No results for
										<span class="searchtextct"> "{{ searchQuery }}" </span>
										found.</span
									>
								</div>
							</div>
							<div
								class="d-flex flex-column align-items-center justify-content-center h-100"
								v-else
							>
								<div>
									<img src="../../assets/nocodequestions.svg" alt="" />
								</div>
								<div class="mt-4">
									<span class="searchnotfoundct">No Data Found </span>
								</div>
							</div>
						</div>
					</div>
					<div
						class="qpc-qbpaginaTion d-flex justify-content-between align-items-center"
					>
						<div style="width: 45%" class="d-flex">
							<span class="qb-gotopage-text p-1">Go to page</span>
							<b-form-input
								style="width: 9%"
								type="text"
								v-model.trim="goToPageDraft"
								min="1"
								class="qb-pagination-num mr-1"
								@keypress="allowNumbers($event)"
								@keyup.enter="
									goToPageDraft === null ||
									goToPageDraft == '' ||
									!isValidPage(goToPageDraft) ||
									draftquestions.length == 0
										? ''
										: goToPageNoDraft(goToPageDraft)
								"
							></b-form-input>
							<b-button
								:disabled="
									goToPageDraft === null ||
										goToPageDraft == '' ||
										!isValidPage(goToPageDraft) ||
										draftquestions.length == 0
								"
								class="qb-pagination-addbtn"
								@click="goToPageNoDraft(goToPageDraft)"
							>
								<span
									><img src="../../assets/whiterightarrow.svg" alt=""
								/></span>
							</b-button>
						</div>

						<div style="width: 30%" class="pagination">
							<b-pagination
								align="center"
								v-model.number="currentPage"
								@input="goToPageNum()"
								:total-rows="totalDraft"
								:per-page="question_count"
								first-number
								last-number
							>
								<template #prev-text
									><span><img src="../../assets/leftvector.svg" alt="" /> </span
								></template>
								<template #next-text
									><span><img src="../../assets/rightarrow.svg" alt=""/></span
								></template>
							</b-pagination>
						</div>
						<div
							style="width: 25%"
							class="qb-gotopage-text mr-2 d-flex justify-content-end"
						>
							Results :
							<span class="ml-1 mr-1" v-if="pageStartDarft > totalDraft">0</span
							><span class="ml-1 mr-1" v-else> {{ pageStartDarft }}</span> -
							{{ pageEndDraft }} <span class="pl-1"></span> of
							<span class="pr-1"></span>{{ totalDraft }}
						</div>
					</div>
				</div>
			</div>
			<div
				v-else-if="draftQuestionsLen == 0"
				class="qpc-main-container mt-2 w-100"
			>
				<div class="d-flex justify-content-between align-items-center">
					<img
						class="pointer"
						@click="goToCreateQuestion"
						src="../../assets/codetest_add.svg"
						alt=""
					/>
				</div>
				<div class="codetestillus">
					<div class="codenodatatext">
						No questions have been created yet. Please click on the<span
							style="font-weight: 600"
						>
							“Add New Question” </span
						><br />
						at the top to create a new
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getcodingquestions,
	getcodingquestion,
	deletecodingquestion,
	getquestiontagsct,
} from "../../utils/apiFunctions.js";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import toastFunction from "../../views/mixin/toast";
import { mapGetters } from "vuex";
export default {
	name: "QPCodingTest",
	mixins: [toastFunction],
	data() {
		return {
			questionkeys: {
				questionKey: [],
			},
			showOverlay: false,
			qno: -1,
			LoaderStatus: false,
			firstloadallqs: true,
			firstloaddftqs: true,
			allQuestionsLength: null,
			draftQuestionsLen: null,
			openmodal: false,
			totalPages: null,
			selectall: false,
			total: null,
			pageStart: "",
			pageEnd: "",
			question_count: 10,
			currentPage: 1,
			goToPage: null,
			goToPageDraft: null,
			pageStartDarft: "",
			pageEndDraft: "",
			totalDraft: null,
			totalPagesDraft: null,
			difficultylevel: [],
			questiontags: [],
			column: "createdAt",
			order: false,
			showsortcard: false,
			searchQuery: "",
			viewtestcase: 0,
			viewdraftquestions: false,
			overlayOpacity: 1,
			overlayBlur: "4",
			question: {
				testCases: [
					{
						inputValue: "",
						outputValue: "",
						visible: "",
					},
				],
			},
			Tags: [],
			allquestions: [],
			searchtag: "",
			draftquestions: [],
			loopVar: 20,
			loopVar2: 2,
			viewTags: false,
			viewDiff: false,
			sort_selected: "Created Date (Desc) Default",
			difficultoptions: [
				{ text: "Difficulty level 1", value: 1 },
				{ text: "Difficulty level 2", value: 2 },
				{ text: "Difficulty level 3", value: 3 },
				{ text: "Difficulty level 4", value: 4 },
				{ text: "Difficulty level 5", value: 5 },
			],

			returnoptions: [
				{ text: "Int", value: "java" },
				{ text: "Float", value: "sql" },
				{ text: "Double", value: "c++" },
				{ text: "Void", value: "c" },
			],
			sortoptions: [
				{ text: "Created Date (Asc)", value: "1" },
				{ text: "Created Date (Desc) Default", value: "2" },
				{ text: "Marks (Asc)", value: "3" },
				{ text: "Marks (Desc)", value: "4" },
				{ text: "Title (Asc)", value: "5" },
				{ text: "Title (Desc)", value: "6" },
			],

			expertiseoptions: [
				{ text: "Front End Developer", value: "FrontEndDeveloper" },
				{ text: "Back End Developer", value: "BackEndDeveloper" },
				{ text: "Graphics designer", value: "GraphicsDesigner" },
				{ text: "Tester", value: "Tester" },
			],
			tagsoptions: [
				{ name: "Array", code: "FrontEndDeveloper" },
				{ name: "Binary Search", code: "BackEndDeveloper" },
				{ name: "Graphics designer", code: "GraphicsDesigner" },
				{ name: "Maths", code: "Tester" },
				{ name: "Chemistry", code: "Tester" },
			],
			language_options: [
				{ text: "View_Topic", value: "GET_TOPIC" },
				{ text: "Add_Topic", value: "PUSH_TOPIC" },
				{ text: "Edit_Topic", value: "PUT_TOPIC" },
				{ text: "Delete_Topic", value: "DELETE_TOPIC" },
				{ text: "View_Test", value: "GET_TEST" },
				{ text: "Add_Test", value: "PUSH_TEST" },
				{ text: "Edit_Test", value: "PUT_TEST" },
				{ text: "Delete_Test", value: "DELETE_TEST" },
				{ text: "View_Question", value: "GET_QUESTION" },
				{ text: "Add_Question", value: "PUSH_QUESTION" },
				{ text: "Edit_Question", value: "PUT_QUESTION" },
				{ text: "Delete_Question", value: "DELETE_QUESTION" },
				{ text: "View_Individual", value: "GET_TEST_INDIVIDUAL" },
				{ text: "Add_Individual", value: "PUSH_TEST_INDIVIDUAL" },
				{ text: "Edit_Individual", value: "PUT_TEST_INDIVIDUAL" },
				{ text: "Delete_Individual", value: "DELETE_TEST_INDIVIDUAL" },
				{ text: "View_Group", value: "GET_TEST_GROUP" },
				{ text: "Add_Group", value: "PUSH_TEST_GROUP" },
			],
		};
	},
	components: {
		Spinner,
	},
	created() {
		this.LoaderStatus = true;
		this.getallcodingquestions();
		this.getTags();
		if (this.$route.query.draft) {
			this.viewdraftquestions = true;
		}
	},

	watch: {
		viewdraftquestions() {
			this.searchQuery = "";
			this.viewDraft();
		},
		Tags() {
			if (this.selectall && this.Tags.length != this.allTags.length) {
				this.selectall = !this.selectall;
			}
			if (this.Tags.length == this.allTags.length) {
				this.selectall = true;
			}
			this.getallcodingquestions();
		},
		searchtag() {
			this.selectall = false;
			this.getTags();
		},
	},
	computed: {
		...mapGetters(["roles"]),
		//checks if entered page number is valid for both draft and created sections
	},

	methods: {
		isValidPage(page) {
			return /^\d*$/.test(page) && page != 0;
		},
		allowNumbers(event) {
			if (!/^\d$/.test(event.key)) {
				event.preventDefault();
			}
		},
		setDraft() {
			this.$router.push({
				name: "QPcodingTest",
				query: {
					draft: true,
				},
			});
		},
		hidesortoptions() {
			this.showsortcard = false;
		},
		checkSelectAll() {
			if (arguments[0]) {
				this.Tags = [...this.allTags];
			} else {
				this.Tags = [];
			}
		},

		async goToDeleteQuestion(flag, key) {
			if (key != null) {
				this.questionkeys.questionKey.push(key);
			}
			console.log(this.questionkeys);
			if (flag) {
				const res = await deletecodingquestion(this.questionkeys);
				if (res.status == 200) {
					this.$bvModal.hide("modal-delete");
					this.$nextTick(() => {
						this.successToast("Question deleted successfully.");
					});
				}
				this.questionkeys.questionKey = [];
				this.getallcodingquestions();
			} else if (!flag) {
				this.$bvModal.show("modal-delete");
			}
		},
		saveSort(index) {
			if (index == "1") {
				this.column = "createdAt";
				this.order = true;
			} else if (index == "2") {
				this.column = "createdAt";
				this.order = false;
			} else if (index == "3") {
				this.column = "marks";
				this.order = true;
			} else if (index == "4") {
				this.column = "marks";
				this.order = false;
			} else if (index == "5") {
				this.column = "title";
				this.order = true;
			} else if (index == "6") {
				this.column = "title";
				this.order = false;
			}
			if (this.viewdraftquestions) this.viewDraft();
			else this.getallcodingquestions();
			this.hidesortoptions();
		},
		selecttestcase(index) {
			this.viewtestcase = index;
		},
		goToPageNo(index) {
			this.currentPage = Math.min(Math.max(1, index), this.totalPages);
			this.goToPage = null;
			if (this.viewdraftquestions) this.viewDraft();
			else this.getallcodingquestions();
		},
		//function for pagination in draft section
		goToPageNoDraft(index) {
			this.currentPage = Math.min(Math.max(1, index), this.totalPagesDraft);
			this.goToPageDraft = null;
			if (this.viewdraftquestions) this.viewDraft();
			else this.getallcodingquestions();
		},
		goToPageNum() {
			if (this.viewdraftquestions) this.viewDraft();
			else this.getallcodingquestions();
		},
		showAllQuestion() {
			this.$router.replace({
				name: "QPcodingTest",
			});
			this.viewdraftquestions = false;
		},
		async openModal(key, i) {
			this.qno = i;
			this.showOverlay = true;
			this.$bvModal.show("viewQues");
			const res = await getcodingquestion(key);
			if (res.status == 200) {
				this.question = res.data.data;
				this.showOverlay = false;
			}
			this.question = res.data.data;
			this.viewtestcase = 0;
			this.$bvModal.show("viewQues");
		},
		goToEditQuestion(key) {
			let data = {
				name: "EditCodingTest",
				query: {
					redirect: "QPcodingTest",
				},
			};
			if (typeof key !== "object") {
				data.query["questionKey"] = key;
			}
			this.$router.push(data);
		},
		goToTryQuestion(key) {
			let data = {
				name: "tryCode",
			};
			if (typeof key !== "object") {
				data.query = {
					questionKey: key,
					status: 1,
				};
			}
			this.$router.push(data);
		},
		goToCreateQuestion(key) {
			let data = {
				name: "BuildingCodeTest",
				query: {
					redirect: "QPcodingTest",
				},
			};
			if (typeof key !== "object") {
				data.query["questionKey"] = key;
			}
			if (this.$route.query.draft) {
				data.query["draft"] = true;
			}
			this.$router.push(data);
		},
		async getallcodingquestions() {
			this.LoaderStatus = true;
			let payload = {
				page: this.currentPage - 1,
				count: this.question_count,
				searchQuery: this.searchQuery,
				filters: {
					category: "",
					difficultyLevel: this.difficultylevel,
					questionTags: this.Tags,
					addToDatabank: false,
					addToPublic: false,
					status: 2,
					active: true,
				},
			};
			if (this.column)
				payload.sortBy = {
					column: this.column,
					order: this.order,
				};
			const res = await getcodingquestions(payload);
			if (res.status == 200) {
				this.allquestions = res.data.data.data;
				if (this.firstloadallqs) {
					this.allQuestionsLength = this.allquestions.length;
					this.firstloadallqs = false;
				}
				this.pageStart = res.data.data.pageStart;
				this.pageEnd = res.data.data.pageEnd;
				this.total = res.data.data.total;
				this.totalPages = Math.ceil(
					parseInt(this.total) / parseInt(this.question_count)
				);
				this.LoaderStatus = false;
			}
		},
		//debounce function for search
		handleInput: function() {
			this.down = true;
			if (this.searchQuery == "") {
				if (this.viewdraftquestions) {
					this.viewDraft();
				} else {
					this.getallcodingquestions();
				}
			} else {
				if (this.timeout) {
					clearTimeout(this.timeout);
				}
				this.timeout = setTimeout(() => {
					if (this.viewdraftquestions) {
						this.viewDraft();
					} else {
						this.getallcodingquestions();
					}
				}, 700); // Adjust the debounce delay as needed
			}
		},
		async viewDraft() {
			this.LoaderStatus = true;
			let payload = {
				page: this.currentPage - 1,
				count: this.question_count,
				searchQuery: this.searchQuery,
				filters: {
					category: "",
					difficultyLevel: [],
					questionTags: [],
					addToDatabank: false,
					addToPublic: false,
					status: 1,
					active: true,
				},
			};
			if (this.column)
				payload.sortBy = {
					column: this.column,
					order: this.order,
				};
			const res = await getcodingquestions(payload);
			if (res.status == 200) {
				this.draftquestions = res.data.data.data;
				if (this.firstloaddftqs) {
					this.draftQuestionsLen = this.draftquestions.length;
					this.firstloaddftqs = false;
				}
				this.pageStartDarft = res.data.data.pageStart;
				this.pageEndDraft = res.data.data.pageEnd;
				this.totalDraft = res.data.data.total;
				this.totalPagesDraft = Math.ceil(
					parseInt(this.totalDraft) / parseInt(this.question_count)
				);
				this.LoaderStatus = false;
			}
		},
		async getTags() {
			let payload = {
				page: 0,
				count: 10,
				searchQuery: this.searchtag,
			};
			const res = await getquestiontagsct(payload);
			this.allTags = res.data.data.data;
			this.$forceUpdate();
		},
		limitedquestion(data) {
			const maxLength = 256;
			if (data.question && data.question.length > maxLength) {
				// If the question exceeds the maxLength, truncate and add "..."
				return data.question.slice(0, maxLength) + ".....";
			}
			// Otherwise, display the full question
			return data.question;
		},
	},
};
</script>
<style>
.QPBuild-main-container {
	padding: 90px 20px 0px 80px;
}

.qpc-yellow-position {
	position: absolute;
	left: 0px;
}

.qpc-main-head {
	font-weight: 600;
	font-size: 18px;
	color: #464667;
}

.qpc-heading-container::before {
	content: "";
	display: inline-block;
	position: absolute;
	width: 27px;
	height: 20px;
	top: 3px;
	left: -11px;
	z-index: -1;
	background: var(--cv-yellow);
	-moz-border-radius: 10px;
	-webkit-border-radius: 10px;
	border-radius: 50%;
}

.qpc-heading-container {
	position: relative;
	z-index: 1;
	font-weight: 600;
	font-size: 18px;
	line-height: 27px;
	/* identical to box height */

	color: #464667;
}

.qpc-main-container {
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	height: calc(100vh - 150px);
	width: 100%;
}

.qpc-totalQuestext {
	font-weight: 500;
	font-size: 14px;
	color: #1d262d;
}

.qpc-totalQuesnum {
	font-weight: 600;
	font-size: 14px;
	color: #333333;
}

.qpc-qbpaginaTion {
	position: absolute;
	width: calc(100%);
	padding: 5px 10px;
	bottom: 0px;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}

.qpc-ques-container {
	height: calc(100vh - 255px);
	overflow: auto;
}

.qpc-question-text {
	font-weight: 400;
	font-size: 14px;
	color: #1a4164;
}

.qpc-tags-text {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.qpc-small-box {
	background: #ffffff;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	font-weight: 500;
	font-size: 11px;
	color: #3f698e;
	padding: 6px 17px;
	margin-right: 20px;
}

.qpc-diff-text {
	font-weight: 500;
	font-size: 14px;
	color: #545454;
}

.qpc-checkbox-text {
	font-weight: 400;
	font-size: 12px;
	color: #595959;
}

.qpc-checkbox-parent .custom-checkbox .custom-control-label::before {
	background: #eef2f5;
	border: 0.2px solid #adaaaa;
	box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.34);
	border-radius: 2px !important;
}

.qpc-checkbox-parent {
	margin: 7px 0px;
}

.qpc-left-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	padding: 15px;
}

.qpc-modal-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	padding: 15px;
	min-height: auto;
	max-height: calc(100vh - 240px);
	overflow: auto;
}

.qpc-search-bar .form-control {
	display: block;
	width: 100%;
	height: calc(1.5em + 0.75rem + 2px);
	padding: 4px 5px 4px 25px;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	background-clip: padding-box;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	background-color: #fcfcfc !important;
	border: 0.5px solid #c4c4c4 !important;
	box-shadow: inset 0px 0px 3px rgba(0, 0, 0, 0.25);
	border-radius: 5px !important;
}

.qpc-modal-head-text {
	font-weight: 500;
	font-size: 13px;
	color: #545454;
}

.qpc-full-ques {
	font-weight: 400;
	font-size: 14px;
	color: #585858;
}

.qpc-modal-card-text {
	font-weight: 500;
	font-size: 13px;
	color: #333333;
}

.qpc-tags-overflow {
	overflow: auto;
	min-height: auto;
	max-height: calc(100vh - 615px);
}

.qpc-tags {
	min-height: auto;
	max-height: calc(100vh - 615px);
}
.bct-preview-head {
	font-size: 13px;
	font-weight: 500;
	color: #333333;
}

.bct-many-testCase-left {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
	background: #fbfafa;
	border-radius: 5px;
}

.bct-many-testCase-sel-text {
	font-weight: 600;
	font-size: 14px;
	color: #3379b3;
	background: #eef2f5;
	border-radius: 5px 5px 0px 0px;
}

.bct-many-testCase-text {
	font-size: 12px;
	font-weight: 500;
	color: #696969;
}

.bct-many-testCase-right {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
}

.bct-TC-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	position: relative;
}

.bct-card-subtext {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.viewdraft:hover,
.viewdraft:active,
.viewdraft {
	border-radius: 3px;
	color: #72738e;
	font-size: 13px;
	background: #fcfcfc;
	border: 1px solid #72738e;
}
.qpc-main-container .sortcontainer {
	position: relative;
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	padding: 5px 10px;
	font-size: 13px;
	width: 240px;
	height: 34px;
}

.qpc-parent .sortcontainer {
	position: relative;
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	padding: 5px 10px;
	font-size: 13px;
	width: 240px;
	height: 34px;
}

.tnt-sortcard-auto {
	background: var(--bg-white);
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
	border-radius: 5px;
	top: 35px;
	right: 2px;
	padding: 5px;
	position: absolute;
	z-index: 7;
	width: 99%;
	font-size: var(--size-11);
	color: #545454;
}
.sorttext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
}
.sortordertext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
}

.search-ques {
	box-sizing: border-box;

	left: 102px;

	background: #ffffff;
	border: 0.5px solid #c4c4c4;
	box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.2);
	border-radius: 3px;
}
.sortline {
	width: 0px;
	height: 19px;
	border: 1px solid #c4c4c4;
	background: #c4c4c4;
}

.searchiconqp {
	position: absolute;
	top: 7px;
	left: 5px;
}
.bct-checboxtext {
	font-weight: 400;
	font-size: 14px;
	color: #545454;
}
.jdtyperadio:nth-child(odd) {
	background: #f4f4f4;
}

.jdtyperadio:nth-child(even) {
	background: #fdfdfd;
}

.searchnotfoundct {
	font-size: 16px;
	color: #696969;
}
.searchtextct {
	color: #696969;
	font-size: 16px;
	font-weight: bold;
}
.textwrap {
	width: 92%;
	text-align: center;
}
.codenodatatext {
	color: #72738e;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	text-align: center;
}
.codetestillus {
	position: absolute;
	bottom: 300px;
	left: 560px;
}
</style>
